import { vRequest } from "@/utils/vRequest";

export const LoginApi = (data: any) => {
  return vRequest.post<any>("/loginExt", data);
};

// 设置语言接口
export const ChangeLang = (data: any) => {
  return vRequest.get<any>("/changeLang", data);
};

// 退出接口
export const Logout = () => {
  return vRequest.delete<any>("/logout");
};

// 获取侧边栏列表接口
export const GetSiderList = () => {
  return vRequest.get<any>(`/menu`);
};
